import { styled } from "@mui/material/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";

export const MemberGrid = styled(DataGridPro)(({ theme }) => ({
  "&& .MuiDataGrid-toolbarContainer": {
    border: "none !important"
  },
  "&& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#5ea3ef"
  },
  "&& .MuiDataGrid-columnHeaderTitle": {
    color: "#fff",
    fontWeight: "900 !important"
  },
  "&& .MuiDataGrid-columnSeparator": {
    display: "none"
  }
}));

export const MemberLink = styled("a")(({ theme }) => ({
  color: "#5ea3ef",
  fontWeight: "900",
  textDecoration: "none"
}));

export const LowRiskLevel = styled("div")(({ theme }) => ({
  background: "#16bf13",
  width: "40px",
  height: "40px",
  borderRadius: "5px"
}));

export const MediumRiskLevel = styled("div")(({ theme }) => ({
  background: "#f8d71e",
  width: "40px",
  height: "40px",
  borderRadius: "5px"
}));

export const HighRiskLevel = styled("div")(({ theme }) => ({
  background: "#dd1616",
  width: "40px",
  height: "40px",
  borderRadius: "5px"
}));
